import React from "react";
import { Card } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { CategoryRequestsManager } from "@/components/admin/CategoryRequestsManager";
import { AppealsManager } from "@/components/admin/AppealsManager";
import { BannedIPsManager } from "@/components/admin/BannedIPsManager";
import { BannedWordsManager } from "@/components/admin/BannedWordsManager";
import { useAppealsCount } from "@/hooks/useAppeals";
import { Badge } from "@/components/ui/badge";
import { AlertTriangle } from "lucide-react";

const AdminModeration = () => {
  const appealsCount = useAppealsCount();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Content Moderation</h1>
        <p className="text-muted-foreground">
          Review and moderate user-generated content
        </p>
      </div>

      <Tabs defaultValue="category-requests" className="space-y-4">
        <TabsList>
          <TabsTrigger value="category-requests">
            Category Requests
          </TabsTrigger>
          <TabsTrigger value="appeals">
            Appeals
            {appealsCount > 0 && (
              <Badge variant="destructive" className="ml-2">
                {appealsCount}
              </Badge>
            )}
          </TabsTrigger>
          <TabsTrigger value="banned-ips">Banned IPs</TabsTrigger>
          <TabsTrigger value="banned-words">Banned Words</TabsTrigger>
          <TabsTrigger value="reports">Reports (Disabled)</TabsTrigger>
          <TabsTrigger value="moderation-queue">Queue (Disabled)</TabsTrigger>
        </TabsList>

        <TabsContent value="category-requests">
          <CategoryRequestsManager />
        </TabsContent>

        <TabsContent value="appeals">
          <AppealsManager />
        </TabsContent>

        <TabsContent value="banned-ips">
          <BannedIPsManager />
        </TabsContent>

        <TabsContent value="banned-words">
          <BannedWordsManager />
        </TabsContent>

        <TabsContent value="reports">
          <Card className="p-6">
            <div className="text-center space-y-4">
              <AlertTriangle className="h-12 w-12 text-muted-foreground mx-auto" />
              <div>
                <h3 className="text-lg font-semibold mb-2">
                  Reports Feature Disabled
                </h3>
                <p className="text-muted-foreground">
                  The advanced reporting system has been temporarily disabled. Please use the
                  Category Requests, Appeals, Banned IPs, and Banned Words tabs for moderation.
                </p>
              </div>
            </div>
          </Card>
        </TabsContent>

        <TabsContent value="moderation-queue">
          <Card className="p-6">
            <div className="text-center space-y-4">
              <AlertTriangle className="h-12 w-12 text-muted-foreground mx-auto" />
              <div>
                <h3 className="text-lg font-semibold mb-2">
                  Moderation Queue Disabled
                </h3>
                <p className="text-muted-foreground">
                  The advanced moderation queue has been temporarily disabled. Please use the
                  Category Requests, Appeals, Banned IPs, and Banned Words tabs for moderation.
                </p>
              </div>
            </div>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AdminModeration;
